function Loading({ isStatic }) {
    const classes = isStatic ? 'loading static' : 'loading';

    return (
        <div className={classes}>
            <div className="quiver">
                <span className="arrows st"></span>
                <span className="arrows nd"></span>
                <span className="arrows rd"></span>
                <span className="arrows th"></span>
                <span className="arrows fth"></span>
            </div>
        </div>
    );
}

export default Loading;
